<template>
    <component
        :is="tag"
        class="address-container"
        :class="[{ inline: line }, theme]"
    >
        <template v-if="!line">
            <span class="street" v-if="streetAddress">
                {{ streetAddress }}
            </span>
            <span class="city">
                {{ cityAddress }}
            </span>
        </template>
        <template v-else>
            <template v-if="info.streetAddress">{{ streetAddress }} </template>
            {{ cityAddress }}
        </template>
    </component>
</template>
<script>
import { mapState } from '@/store/helpers';

export default {
    props: {
        line: {
            type: Boolean,
            default: false
        },
        tag: {
            type: String,
            default: 'div'
        },
        theme: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {};
    },
    computed: {
        ...mapState({
            info: store => store.listingDetail.info || {}
        }),
        streetAddress({ info }) {
            let { streetAddress = '' } = info;
            return streetAddress.replace(/, */g, ', ');
        },
        cityAddress({ info }) {
            let { cityAddress = '' } = info;
            return cityAddress.replace(/, */g, ', ');
        }
    }
};
</script>
<style lang="scss">
.address-container {
    font-weight: normal;
    font-family: var(--font-normal);
    color: var(--color-text);
    font-size: 0;
    &.inline {
        font-size: 16px;
    }
    .street {
        font-weight: 700;
        font-family: var(--font-medium);
        font-size: 16px;
        margin-right: 6px;
    }
    .city {
        font-size: 14px;
    }
    @media (max-width: 600px) {
        &.inline {
            font-family: var(--font-bold);
            line-height: 19px;
        }
        .street {
            font-size: 14px;
        }
        .city {
            font-size: 12px;
        }
    }
}
.address-container.black {
    font-family: var(--font-bold);
    line-height: 34px;
    color: #191919;
    .street {
        font-family: var(--font-bold);
        font-size: 24px;
    }
    .city {
        font-size: 24px;
    }
    @media (max-width: 600px) {
        &.inline {
            font-size: 16px;
            line-height: 19px;
        }
    }
}
.address-container.dark {
    font-weight: 700;
    line-height: 1.2;
    .street {
        font-family: var(--font-normal);
        color: white;
        font-size: 16px;
    }
    .city {
        color: #8195bd;
        font-size: 14px;
    }
}
.address-container.big-font {
    .street {
        font-size: 20px;
    }
    .city {
        font-size: 20px;
    }
    @media (max-width: 600px) {
        .street {
            font-size: 18px;
        }
        .city {
            font-size: 16px;
        }
    }
}
</style>
